module.exports = __webpack_public_path__ + "static/media/joker.1f3d0f84.jpg";